import React from 'react';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import { SvgIcon } from 'ui/SvgIcon';
import XIcon from 'ui/Icons/tabler/x.component.svg';
import PencilIcon from 'ui/Icons/tabler/pencil.component.svg';

interface IActionButtonProps {
  action: (removePath: string, index: number) => void;
  pathPrefix: string;
  productType: string;
  index: number;
}

const GA_FLOW_TAG = 'act-bkd';

export const RemoveHeadlineButton = (props: IActionButtonProps) => {
  const { dynamicParameters } = useDynamicParameters();

  const { action: removeHeadlineLineItemAction, pathPrefix, productType, index } = props;

  return (
    <span className="w-6">
      <button
        className="delete rounded-full p-0 w-6 h-6 bg-white hover:bg-brown-40 border border-solid border-brown-80 cursor-pointer font-pt-sans flex justify-center items-center"
        onClick={() => {
          if (dynamicParameters.GOOGLE_ANALYTICS_TRACK_ID && productType === 'Bespoke') {
            // @ts-ignore
            window.gtag('event', `${GA_FLOW_TAG}_remove-item`, {});
          }
          removeHeadlineLineItemAction(
            `${pathPrefix === '' ? '' : `${pathPrefix}.`}${productType === '' ? '' : `${productType}.`}items`,
            index
          );
        }}
      >
        <SvgIcon IconComponent={XIcon} className="w-4 h-4 fill-transparent stroke-brown-80 stroke-2" />
      </button>
    </span>
  );
};

export const EditHeadlineButton = (props: IActionButtonProps) => {
  const { action, pathPrefix, productType, index } = props;

  return (
    <span className="w-6">
      <button
        className="delete rounded-full p-0 w-6 h-6 bg-white hover:bg-brown-40 border border-solid border-brown-80 cursor-pointer font-pt-sans flex justify-center items-center"
        onClick={() => {
          action(`${pathPrefix}${productType}.items`, index);
        }}
      >
        <SvgIcon IconComponent={PencilIcon} className="w-[12px] h-[12px] fill-brown-80" />
      </button>
    </span>
  );
};
